import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TitleWithInfo from '../../Common/TitleWithInfo/TitleWithInfo';
import {
  filter_icon,
  filter_icon_vector,
} from '../../Common/SvgIcon/CommonSvgIcons';
import { formatNumber } from '../../utils/NumberFormatter';
import { useSelector } from 'react-redux';

function generateDynamicLinearGradient(value, colorType) {
  if (typeof value !== 'number') {
    return '#fff';
  }

  const colorStops = [
    // { value: 1, color: '#008481' },
    // { value: 0.9, color: '#008481' },
    // { value: 0.8, color: '#1a918e' },
    // { value: 0.7, color: '#339d9a' },
    // { value: 0.6, color: '#4da9a7' },
    // { value: 0.5, color: '#66b5b3' },
    // { value: 0.4, color: '#7fc1bf' },
    // { value: 0.3, color: '#99cecd' },
    // { value: 0.2, color: '#b3dbda' },
    // { value: 0.1, color: '#cce6e6' },
    // { value: 0, color: '#F3F9F9' },

    { value: 1, color: '#2D8955FF' },
    { value: 0.9, color: '#2D8955E6' },
    { value: 0.8, color: '#2D8955CC' },
    { value: 0.7, color: '#2D8955B3' },
    { value: 0.6, color: '#2D895599' },
    { value: 0.5, color: '#2D895580' },
    { value: 0.4, color: '#2D895566' },
    { value: 0.3, color: '#2D89554D' },
    { value: 0.2, color: '#2D895533' },
    { value: 0.1, color: '#2D89551A' },
    { value: 0, color: '#F3F9F9' },
  ];

  let stop1;

  if (colorType === 'type2') {
    stop1 = colorStops.find((stop) => value.toFixed(1) >= stop.value);
  }

  const background = `${stop1?.color}`;
  return background;
}

// const HeatmapCell = styled.div`
//   background: ${(props) =>
//     generateDynamicLinearGradient(props?.value, props?.colorType)};
//   border: 1px solid white;
//   height: ${(props) =>
//     props?.xAxis === AxisHour
//       ? 'unset'
//       : props?.xAxis === AxisWeek
//       ? '40px'
//       : props?.xAxis === AxisQuarter
//       ? '40px'
//       : '35px'};
//   width: ${(props) =>
//     props?.xAxis === AxisHour
//       ? 'unset'
//       : props?.xAxis === AxisWeek
//       ? '35px'
//       : props?.xAxis === AxisQuarter
//       ? '40px'
//       : '35px'};
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   text-align: center;
//   color: #2a2929;
//   font-family: Inter;
//   font-size: 13px;
//   font-weight: 400;

//   ${(props) => {
//     if (props?.value === 'hide') {
//       return 'opacity:0';
//     }
//   }};
// `;
const X_AxisLabel = styled.div`
  justify-content: center;
  align-items: center;
  margin-top: ${(props) =>
    props?.currentXAxis === AxisMonth
      ? '5px'
      : props?.currentXAxis === AxisWeek
      ? '5px'
      : '5px'};
  margin-left: 110px;
  font-size: 14px;
  margin-left: ${(props) =>
    props?.currentXAxis === AxisHour
      ? '30px'
      : props?.currentXAxis === AxisMonth
      ? '40px'
      : props?.currentXAxis === AxisWeek
      ? '40px'
      : '50px'};
  color: #2a2929;
  font-family: inherit;

  font-weight: 400;
`;

const GridContainer = styled.div`
  width: ${(props) =>
    props?.xAxis === AxisHour
      ? '80%'
      : props?.xAxis === AxisMonth
      ? '60%'
      : props?.xAxis === AxisWeek
      ? '30%'
      : props?.xAxis === AxisQuarter
      ? '25%'
      : 'unset'};
`;
const HeatmapRowContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props?.xAxis === AxisHour
      ? 'repeat(24, 25px)'
      : props?.xAxis === AxisMonth
      ? 'repeat(12,  35px)'
      : props?.xAxis === AxisWeek
      ? 'repeat(7, 35px)'
      : props?.xAxis === AxisQuarter
      ? 'repeat(4, 40px)'
      : 'repeat(10, 70px)'};
`;

const HeatmapCell = styled.div`
  background: ${(props) =>
    generateDynamicLinearGradient(props?.value, props?.colorType)};
  border: 1px solid white;
  height: ${(props) =>
    props?.xAxis === AxisHour
      ? 'unset'
      : props?.xAxis === AxisWeek
      ? '40px'
      : props?.xAxis === AxisQuarter
      ? '40px'
      : '35px'};
  width: ${(props) =>
    props?.xAxis === AxisHour
      ? 'unset'
      : props?.xAxis === AxisWeek
      ? '35px'
      : props?.xAxis === AxisQuarter
      ? '40px'
      : '35px'};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #2a2929;
  font-family: inherit;
  font-size: 13px;
  font-weight: 400;
  position: relative; // Added for tooltip positioning

  ${(props) => {
    if (props?.value === 'hide') {
      return 'opacity: 0';
    }
  }};
`;

const TooltipContent = styled.div``;
const HeatmapCellWithTooltip = ({
  xAxis,
  value,
  colorType,
  tooltip,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  channel,
  titleValue,
  ...props
}) => {
  // Split tooltip into lines
  const tooltipLines = tooltip.split('\n');

  return (
    <HeatmapCell
      xAxis={xAxis}
      value={value}
      colorType={colorType}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...props}
    >
      {isHovered && (
        <Tooltip>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ fontWeight: '600' }}>
              {channel === 'chatter' ? 'Chatter Volume' : `Engagement:`}
            </div>
            <div>{channel !== 'chatter' && titleValue}</div>
          </div>{' '}
          {tooltipLines.map((line, index) => {
            const parts = line?.split(':');

            return (
              <div key={index} style={{ padding: '2px 0' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontFamily: 'Inter',
                    color: '#292A2A',
                  }}
                >
                  <div style={{ fontWeight: '600' }}> {parts[0]}:&nbsp;</div>
                  <div>{formatNumber(parts[1])}</div>
                </div>

                {index < tooltipLines.length - 1 && (
                  <hr style={{ border: '1px solid #ccc', margin: '4px 0' }} />
                )}
              </div>
            );
          })}
        </Tooltip>
      )}
    </HeatmapCell>
  );
};

const Tooltip = styled.div`
  position: absolute;
  background: #ffffff;
  color: #292a2a;
  border: 1px solid #ccc;
  padding: 4px 8px;
  border-radius: 4px;
  z-index: 10;
  text-align: left;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  font-family: inherit;
  font-size: 12px;
  pointer-events: none;
`;

const HeatmapRow = ({
  rowData,
  likesData,
  repliesData,
  retweetData,
  sharesData,
  commentsData,
  viewsData,
  colorType = 'type1',
  min,
  max,
  currentXAxis,
  channel,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null); // Track the hovered cell index

  return (
    <HeatmapRowContainer xAxis={currentXAxis}>
      {rowData?.map((value, index) => {
        const tooltipParts = [];
        let showTotal = true;

        if (retweetData?.[index] != null) {
          showTotal = false;
          tooltipParts.push(`Reposts: ${retweetData[index]}`);
        }
        if (likesData?.[index] != null) {
          showTotal = false;
          tooltipParts.push(`Likes: ${likesData[index]}`);
        }
        if (repliesData?.[index] != null) {
          showTotal = false;
          tooltipParts.push(`Replies: ${repliesData[index]}`);
        }
        if (sharesData?.[index] != null) {
          showTotal = false;
          tooltipParts.push(`Shares: ${sharesData[index]}`);
        }
        if (commentsData?.[index] != null) {
          showTotal = false;
          tooltipParts.push(`Comments: ${commentsData[index]}`);
        }
        if (viewsData?.[index] != null) {
          showTotal = false;
          tooltipParts.push(`Views: ${viewsData[index]}`);
        }

        const tooltip = showTotal
          ? `Volume: ${value}`
          : tooltipParts.join('\n');

        return (
          <HeatmapCellWithTooltip
            key={index}
            channel={channel}
            xAxis={currentXAxis}
            value={
              value === null || value === undefined
                ? 'hide'
                : (value - min) / (max - min)
            }
            titleValue={formatNumber(value)}
            colorType={colorType}
            tooltip={tooltip}
            isHovered={hoveredIndex === index}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          />
        );
      })}
    </HeatmapRowContainer>
  );
};

const HeatmapHeader = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props?.xAxis === AxisHour
      ? 'repeat(24, 25px)'
      : props?.xAxis === AxisMonth
      ? 'repeat(12,  35px)'
      : props?.xAxis === AxisWeek
      ? 'repeat(7, 35px)'
      : props?.xAxis === AxisQuarter
      ? 'repeat(4,40px)'
      : 'repeat(10, 70px)'};
`;

const HeatmapRowWrapper = styled.div`
  display: flex;
`;

const YLabelCell = styled.div`
  display: flex;
  font-size: 14px;
  justify-content: end;
  margin-right: 15px;
  align-items: center;
  justify-content: center;
  color: #2a2929;
  font-family: inherit;
`;

const MainContainer = styled.div`
  margin-top: 45px;
  display: flex;
  gap: 10px;
  justify-content: ${(props) =>
    props?.xAxis === AxisHour || props?.xAxis === AxisMonth
      ? 'space-evenly'
      : 'center'};
  padding-right: 20px;
  margin-left: ${(props) => (props?.xAxis === AxisHour ? '-35px' : 'unset')};
  min-height: 120px;
  align-items: center;
  margin-bottom: 45px;
  min-width:840px;
`;

const HeatmapGraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > div {
    display: grid;
    grid-template-columns: ${(props) =>
      props?.xAxis === AxisHour
        ? 'repeat(24, 25px)'
        : props?.xAxis === AxisMonth
        ? 'repeat(12,  35px)'
        : props?.xAxis === AxisWeek
        ? 'repeat(7, 35px)'
        : props?.xAxis === AxisQuarter
        ? 'repeat(4, 40px)'
        : 'repeat(10, 70px)'};
  }
`;

const ColorRangeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: ${(props) =>
    props?.xAxis === AxisMonth
      ? '40px'
      : props?.xAxis === AxisHour
      ? '-45px'
      : '80px'};
  & > div {
    width: 20px;
    height: 20px;
    cursor: pointer;

    & .label {
      display: none;
    }
  }

  .colorIndicatorType3 {
    background: linear-gradient(
      180deg,
      #6f62fe 5.28%,
      #75b0f5 20%,
      #ffffff 40%,
      #ffffff 50%,
      #ffa7a9 82%,
      #fc746c 100%
    );
    border: 1px grey solid;
  }
  .colorIndicatorType2 {
    background: linear-gradient(
      0deg,
      #2d895500,
      /* Fully transparent */ #2d895533,
      /* 0.2 alpha */ #2d895566,
      /* 0.4 alpha */ #2d8955b3,
      /* 0.7 alpha */ #2d8955ff /* Fully opaque */
    );
  }
  // .colorIndicatorType2 {
  //   background: linear-gradient(
  //     180deg,
  //     #008481 0%,
  //     /* Deep teal */ #00d5d0 20%,
  //     /* Bright cyan */ #b4eae9 40%,
  //     /* Soft aqua */ #f6fdfc 70%,
  //     /* Near white */ #ffffff 100% /* Pure white */
  //   );
  // }
  .colorIndicatorType1 {
    background: linear-gradient(
      180deg,
      #c20000 5.28%,
      #ec3539 16.22%,
      #e9a9aa 29.5%,
      #fceaea 46.5%,
      #ffe49c 50%,
      #88f8b6 67%,
      #0cbb53 84.5%,
      #008335 100%
    );
    border: 1px grey solid;
  }

  .activeType {
    height: 510px;
    position: relative;

    & > .label {
      display: flex;
      position: absolute;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      right: -50px;
      font-size: 15px;
      color: #2a2929;

      font-weight: 400;
      text-align: center;
    }
  }
`;

const Sentiment = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 20px 40px;
  line-height: 25px;
  gap: 10px;
  overflow: hidden;
  overflow: auto;
  flex-wrap: wrap;
  & > div:first-child {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Title = styled.span`
  font-family: inherit;
  font-size: 18px;
  color: #2a2929;
  font-weight: 600;
  margin: 15px 0px 20px -15px;
`;

const AxisHour = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
];

const AxisWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const AxisQuarter = ['Q1', 'Q2', 'Q3', 'Q4'];

const AxisMonth = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

// const yAxis = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

const StyledButton = styled.button`
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  // background: #353cf7;
  // color: var(--Headlines, rgba(42, 136, 107, 1));
  // border: 1px solid var(--Headlines, rgba(42, 136, 107, 1));

  border: 1px solid rgba(45, 137, 85, 1);
  color: rgba(45, 137, 85, 1);
  background: white;
  height: 35px;
  padding: 5px 20px;
  border-radius: 10px;

  // border: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: inherit;
  gap: 5px;
`;

const Options = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
  cursor: pointer;
  font-size: 12px;
  color: #2a2929;

  font-family: inherit;
  input[type='radio']:not(:disabled) {
    opacity: 1;
    cursor: pointer;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  border-top: 1px solid #a2a2a2;
  padding-top: 10px;
`;

const Button = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  font-family: inherit;
  ${({ apply }) =>
    apply
      ? `
    background-color: rgba(45, 137, 85, 1);
    color: white;
  `
      : `
    background-color: #f5f5f5;
      color: #2a2929;

  `}

  &:hover {
    opacity: 0.9;
  }
`;
const LabelText = styled.div`
  font-size: 12px;
  font-family: inherit;
  color: #2a2929;
`;
const FilterOptions = ({
  handleFilterChange,
  selectedOptions,
  setSelectedOptions,
}) => {
        const { personalDetailsData } =
            useSelector((state) => state.tenantSetting) || {};
      
        let col=personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'green';
   let col2=personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'rgba(45, 137, 85, 1)';
  
  
  const handleRadioChange = (event) => {
    const { id, name } = event.target;
    setSelectedOptions((prev) => {
      const updatedOptions = prev.filter((item) => !item.startsWith(name[0]));

      return [...updatedOptions, id];
    });
  };
  const isDisabled = (id) => {
    return selectedOptions.some((option) => option.slice(1) === id.slice(1));
  };
  const [showFilterOptions, setShowFilterOptions] = useState(false);

  return (
    <DropdownContainer>
      <StyledButton onClick={() => setShowFilterOptions(!showFilterOptions)}>
        Filters {filter_icon_vector}
      </StyledButton>
      {showFilterOptions && (
        <DropdownMenu>
          <LabelText>X-axis</LabelText>
          <Options col={col}>
            <input
              type='radio'
              name='xaxis'
              id='xhour'
              checked={selectedOptions.includes('xhour')}
              onChange={(event) => {
                handleRadioChange(event);
              }}
              disabled={isDisabled('xhour')}
              style={{
                width: '12px',
                height: '12px',
                border:
                  '1px solid ' +
                  (selectedOptions.includes('xhour') ? 'green' : '#ccc'),
                backgroundColor: selectedOptions.includes('xhour')
                  ? col ? col : 'green'
                  : '#fff',
                borderRadius: '50%',
                cursor:
                  isDisabled('xhour') && !selectedOptions.includes('xhour')
                    ? 'not-allowed'
                    : 'pointer',
                appearance: 'none',
                display: 'inline-block',
                position: 'relative',
                marginTop: '1.5px',
                marginRight: '5px',
              }}
            />
            Hour of Day
          </Options>
          <Options>
            <input
              type='radio'
              name='xaxis'
              id='xday'
              checked={selectedOptions.includes('xday')}
              onChange={(event) => {
                handleRadioChange(event);
              }}
              disabled={isDisabled('xday')}
              style={{
                width: '12px',
                height: '12px',
                border:
                  '1px solid ' +
                  (selectedOptions.includes('xday') ? 'green' : '#ccc'),
                backgroundColor: selectedOptions.includes('xday')
                  ? col ? col :'green'
                  : '#fff',
                borderRadius: '50%',
                cursor:
                  isDisabled('xday') && !selectedOptions.includes('xday')
                    ? 'not-allowed'
                    : 'pointer',
                appearance: 'none',
                display: 'inline-block',
                position: 'relative',
                marginTop: '1.5px',
                marginRight: '5px',
              }}
            />
            Day of Week
          </Options>
          <Options>
            <input
              type='radio'
              name='xaxis'
              id='xquarter'
              checked={selectedOptions.includes('xquarter')}
              onChange={(event) => {
                handleRadioChange(event);
              }}
              disabled={isDisabled('xquarter')}
              style={{
                width: '12px',
                height: '12px',
                border:
                  '1px solid ' +
                  (selectedOptions.includes('xquarter') ? 'green' : '#ccc'),
                backgroundColor: selectedOptions.includes('xquarter')
                  ?  col ? col : 'green'
                  : '#fff',
                borderRadius: '50%',
                cursor:
                  isDisabled('xquarter') &&
                  !selectedOptions.includes('xquarter')
                    ? 'not-allowed'
                    : 'pointer',
                appearance: 'none',
                display: 'inline-block',
                position: 'relative',
                marginTop: '1.5px',
                marginRight: '5px',
              }}
            />
            Quarter of Year
          </Options>
          <Options>
            <input
              type='radio'
              name='xaxis'
              id='xmonth'
              checked={selectedOptions.includes('xmonth')}
              onChange={(event) => {
                handleRadioChange(event);
              }}
              disabled={isDisabled('xmonth')}
              style={{
                width: '12px',
                height: '12px',
                border:
                  '1px solid ' +
                  (selectedOptions.includes('xmonth') ? 'green' : '#ccc'),
                backgroundColor: selectedOptions.includes('xmonth')
                  ? col ? col : 'green'
                  : '#fff',
                borderRadius: '50%',
                cursor:
                  isDisabled('xmonth') && !selectedOptions.includes('xmonth')
                    ? 'not-allowed'
                    : 'pointer',
                appearance: 'none',
                display: 'inline-block',
                position: 'relative',
                marginTop: '1.5px',
                marginRight: '5px',
              }}
            />
            Month of Year
          </Options>

          <LabelText>Y-axis</LabelText>
          {/* <Options>
            <input
              type='radio'
              name='yaxis'
              id='yhour'
              checked={selectedOptions.includes('yhour')}
              onChange={(event) => {
                handleRadioChange(event);
              }}
              disabled={isDisabled('yhour')}
            />
            Hour of Day
          </Options> */}
          <Options>
            <input
              type='radio'
              name='yaxis'
              id='yday'
              checked={selectedOptions.includes('yday')}
              onChange={(event) => {
                handleRadioChange(event);
              }}
              disabled={isDisabled('yday')}
              style={{
                width: '12px',
                height: '12px',
                border:
                  '1px solid ' +
                  (selectedOptions.includes('yday') ? 'green' : '#ccc'),
                backgroundColor: selectedOptions.includes('yday')
                  ? col ? col :'green'
                  : '#fff',
                borderRadius: '50%',
                cursor:
                  isDisabled('yday') && !selectedOptions.includes('yday')
                    ? 'not-allowed'
                    : 'pointer',
                appearance: 'none',
                display: 'inline-block',
                position: 'relative',
                marginTop: '1.5px',
                marginRight: '5px',
              }}
            />
            Day of Week
          </Options>
          <Options>
            <input
              type='radio'
              name='yaxis'
              id='yquarter'
              checked={selectedOptions.includes('yquarter')}
              onChange={(event) => {
                handleRadioChange(event);
              }}
              disabled={isDisabled('yquarter')}
              style={{
                width: '12px',
                height: '12px',
                border:
                  '1px solid ' +
                  (selectedOptions.includes('yquarter') ? 'green' : '#ccc'),
                backgroundColor: selectedOptions.includes('yquarter')
                  ? col ? col :'green'
                  : '#fff',
                borderRadius: '50%',
                cursor:
                  isDisabled('yquarter') &&
                  !selectedOptions.includes('yquarter')
                    ? 'not-allowed'
                    : 'pointer',
                appearance: 'none',
                display: 'inline-block',
                position: 'relative',
                marginTop: '1.5px',
                marginRight: '5px',
              }}
            />
            Quarter of Year
          </Options>
          <Options>
            <input
              type='radio'
              name='yaxis'
              id='ymonth'
              checked={selectedOptions.includes('ymonth')}
              onChange={(event) => {
                handleRadioChange(event);
              }}
              disabled={isDisabled('ymonth')}
              style={{
                width: '12px',
                height: '12px',
                border:
                  '1px solid ' +
                  (selectedOptions.includes('ymonth') ? 'green' : '#ccc'),
                backgroundColor: selectedOptions.includes('ymonth')
                  ? col ? col : 'green'
                  : '#fff',
                borderRadius: '50%',
                cursor:
                  isDisabled('ymonth') && !selectedOptions.includes('ymonth')
                    ? 'not-allowed'
                    : 'pointer',
                appearance: 'none',
                display: 'inline-block',
                position: 'relative',
                marginTop: '1.5px',
                marginRight: '5px',
              }}
            />
            Month of Year
          </Options>

          <ButtonContainer>
            <Button onClick={() => setShowFilterOptions(false)}>Cancel</Button>
            <Button
            style={{
              backgroundColor:col2 ? col2 : 'rgba(45, 137, 85, 1)'
            }}
              onClick={() => {
                handleFilterChange(selectedOptions);
                setShowFilterOptions(false);
              }}
              apply
            >
              Apply
            </Button>
          </ButtonContainer>
        </DropdownMenu>
      )}
    </DropdownContainer>
  );
};

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownMenu = styled.div`
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  width: 200px;
  right: 0px;
`;
const Span = styled.span`
  color: #2a2929;
  font-family: inherit;
  font-size: 11px;
  font-weight: 400;
  align-self: flex-end;
  margin-right: 10px;
  margin-bottom: -4px;
  font-family: inherit;
`;
const XLabel = styled.span`
  font-size: 14px;
  display: flex;
  color: #2a2929;
  justify-content: center;
  margin-top: 30px;
  font-family: inherit;
  font-weight: 600;
  margin-left: ${(props) =>
    props?.currentXAxis === AxisQuarter ? '10px' : 'unset'};
`;
const YLabel = styled.span`
  font-size: 14px;
  font-family: inherit;
  color: #2a2929;
  transform: ${(props) =>
    props?.currentXAxis === AxisHour
      ? 'translateY(-200%) rotate(-90deg)'
      : 'translateY(-100%) rotate(-90deg)'};
  display: inline-block;
  font-weight: 600;
  min-width: ${(props) =>
    props?.currentXAxis === AxisHour ? 'unset' : '145px'};
`;

const DynamicCorrelationGraph = ({
  correlationAnalysisData,
  startDate,
  likesData,
  repliesData,
  retweetData,
  commentsData,
  sharesData,
  endDate,
  viewsData,
  channel = 'topic',
  infoText='Heatmap tracking user engagement over time, showing the type and frequency of interactions during each period.'
}) => {
  useEffect(() => {
    handleFilterChange(['xhour', 'yday']);
  }, [correlationAnalysisData]);
  const [selectedColor, setSelectedColor] = useState('type2');
  const isEmpty = Object.entries(correlationAnalysisData ?? {}).length === 0;
  const [selectedOptions, setSelectedOptions] = useState(['xhour', 'yday']);
  const [xAxis, setXAxis] = useState('Hour of day');
  const [yAxis, setYAxis] = useState('Day of week');

  const transposeMatrix = (matrix) => {
    if (!isEmpty) {
      if (matrix !== null || matrix !== undefined) {
        return matrix?.[0]?.map((_, colIndex) =>
          matrix?.map((row) => row[colIndex])
        );
      } else return [];
    } else return [];
  };
  const cleanedData = [];
  for (const key in correlationAnalysisData) {
    if (!isEmpty) {
      cleanedData[key] = correlationAnalysisData[key];
    }
  }
  const cleanedLikesData = [];
  for (const key in likesData || []) {
    if (!isEmpty) {
      cleanedLikesData[key] = likesData[key] || [];
    }
  }

  const likesMapping = {
    'hour-day': transposeMatrix(cleanedLikesData['hour_day']),
    'hour-quarter': transposeMatrix(cleanedLikesData['hour_quarter']),
    'hour-month': transposeMatrix(cleanedLikesData['hour_month']),
    'day-hour': cleanedLikesData['hour_day'],
    'day-quarter': transposeMatrix(cleanedLikesData['day_quarter']),
    'day-month': transposeMatrix(cleanedLikesData['day_month']),
    'quarter-hour': cleanedLikesData['hour_quarter'],
    'quarter-day': cleanedLikesData['day_quarter'],
    'quarter-month': transposeMatrix(cleanedLikesData['quarter_month']),
    'month-hour': cleanedLikesData['hour_month'],
    'month-day': cleanedLikesData['day_month'],
    'month-quarter': cleanedLikesData['quarter_month'],
  };
  const dataMapping = {
    'hour-day': cleanedData['hour_day']
      ? transposeMatrix(cleanedData['hour_day'])
      : [],
    'hour-quarter': cleanedData['hour_quarter']
      ? transposeMatrix(cleanedData['hour_quarter'])
      : [],
    'hour-month': cleanedData['hour_month']
      ? transposeMatrix(cleanedData['hour_month'])
      : [],
    'day-hour': cleanedData['hour_day'] || [],
    'day-quarter': cleanedData['day_quarter']
      ? transposeMatrix(cleanedData['day_quarter'])
      : [],
    'day-month': cleanedData['day_month']
      ? transposeMatrix(cleanedData['day_month'])
      : [],
    'quarter-hour': cleanedData['hour_quarter'] || [],
    'quarter-day': cleanedData['day_quarter'] || [],
    'quarter-month': cleanedData['quarter_month']
      ? transposeMatrix(cleanedData['quarter_month'])
      : [],
    'month-hour': cleanedData['hour_month'] || [],
    'month-day': cleanedData['day_month'] || [],
    'month-quarter': cleanedData['quarter_month'] || [],
  };

  const cleanedRepliesData = [];
  var repliesMapping = {};
  if (repliesData !== undefined) {
    for (const key in repliesData || []) {
      if (!isEmpty) {
        cleanedRepliesData[key] = repliesData[key] || [];
      }
    }
    repliesMapping = {
      'hour-day': transposeMatrix(cleanedRepliesData['hour_day']),
      'hour-quarter': transposeMatrix(cleanedRepliesData['hour_quarter']),
      'hour-month': transposeMatrix(cleanedRepliesData['hour_month']),
      'day-hour': cleanedRepliesData['hour_day'],
      'day-quarter': transposeMatrix(cleanedRepliesData['day_quarter']),
      'day-month': transposeMatrix(cleanedRepliesData['day_month']),
      'quarter-hour': cleanedRepliesData['hour_quarter'],
      'quarter-day': cleanedRepliesData['day_quarter'],
      'quarter-month': transposeMatrix(cleanedRepliesData['quarter_month']),
      'month-hour': cleanedRepliesData['hour_month'],
      'month-day': cleanedRepliesData['day_month'],
      'month-quarter': cleanedRepliesData['quarter_month'],
    };
  }

  const cleanedRetweetsData = [];
  var retweetMapping = {};
  if (retweetData !== undefined) {
    for (const key in retweetData || []) {
      if (!isEmpty) {
        cleanedRetweetsData[key] = retweetData[key] || [];
      }
    }
    retweetMapping = {
      'hour-day': transposeMatrix(cleanedRetweetsData['hour_day']),
      'hour-quarter': transposeMatrix(cleanedRetweetsData['hour_quarter']),
      'hour-month': transposeMatrix(cleanedRetweetsData['hour_month']),
      'day-hour': cleanedRetweetsData['hour_day'],
      'day-quarter': transposeMatrix(cleanedRetweetsData['day_quarter']),
      'day-month': transposeMatrix(cleanedRetweetsData['day_month']),
      'quarter-hour': cleanedRetweetsData['hour_quarter'],
      'quarter-day': cleanedRetweetsData['day_quarter'],
      'quarter-month': transposeMatrix(cleanedRetweetsData['quarter_month']),
      'month-hour': cleanedRetweetsData['hour_month'],
      'month-day': cleanedRetweetsData['day_month'],
      'month-quarter': cleanedRetweetsData['quarter_month'],
    };
  }
  const cleanedCommentsCount = [];
  var commentsMapping = {};
  if (commentsData !== undefined) {
    for (const key in commentsData || []) {
      if (!isEmpty) {
        cleanedCommentsCount[key] = commentsData[key] || [];
      }
    }
    commentsMapping = {
      'hour-day': transposeMatrix(cleanedCommentsCount['hour_day']),
      'hour-quarter': transposeMatrix(cleanedCommentsCount['hour_quarter']),
      'hour-month': transposeMatrix(cleanedCommentsCount['hour_month']),
      'day-hour': cleanedCommentsCount['hour_day'],
      'day-quarter': transposeMatrix(cleanedCommentsCount['day_quarter']),
      'day-month': transposeMatrix(cleanedCommentsCount['day_month']),
      'quarter-hour': cleanedCommentsCount['hour_quarter'],
      'quarter-day': cleanedCommentsCount['day_quarter'],
      'quarter-month': transposeMatrix(cleanedCommentsCount['quarter_month']),
      'month-hour': cleanedCommentsCount['hour_month'],
      'month-day': cleanedCommentsCount['day_month'],
      'month-quarter': cleanedCommentsCount['quarter_month'],
    };
  }
  const cleanedSharesCount = [];
  var sharesMapping = {};
  if (sharesData !== undefined) {
    for (const key in sharesData || []) {
      if (!isEmpty) {
        cleanedSharesCount[key] = sharesData[key] || [];
      }
    }
    sharesMapping = {
      'hour-day': transposeMatrix(cleanedSharesCount['hour_day']),
      'hour-quarter': transposeMatrix(cleanedSharesCount['hour_quarter']),
      'hour-month': transposeMatrix(cleanedSharesCount['hour_month']),
      'day-hour': cleanedSharesCount['hour_day'],
      'day-quarter': transposeMatrix(cleanedSharesCount['day_quarter']),
      'day-month': transposeMatrix(cleanedSharesCount['day_month']),
      'quarter-hour': cleanedSharesCount['hour_quarter'],
      'quarter-day': cleanedSharesCount['day_quarter'],
      'quarter-month': transposeMatrix(cleanedSharesCount['quarter_month']),
      'month-hour': cleanedSharesCount['hour_month'],
      'month-day': cleanedSharesCount['day_month'],
      'month-quarter': cleanedSharesCount['quarter_month'],
    };
  }
  const cleanedViewsData = [];
  var viewsMapping = {};
  if (viewsData !== undefined) {
    for (const key in viewsData || []) {
      if (!isEmpty) {
        cleanedViewsData[key] = viewsData[key] || [];
      }
    }
    viewsMapping = {
      'hour-day': transposeMatrix(cleanedViewsData['hour_day']),
      'hour-quarter': transposeMatrix(cleanedViewsData['hour_quarter']),
      'hour-month': transposeMatrix(cleanedViewsData['hour_month']),
      'day-hour': cleanedViewsData['hour_day'],
      'day-quarter': transposeMatrix(cleanedViewsData['day_quarter']),
      'day-month': transposeMatrix(cleanedViewsData['day_month']),
      'quarter-hour': cleanedViewsData['hour_quarter'],
      'quarter-day': cleanedViewsData['day_quarter'],
      'quarter-month': transposeMatrix(cleanedViewsData['quarter_month']),
      'month-hour': cleanedViewsData['hour_month'],
      'month-day': cleanedViewsData['day_month'],
      'month-quarter': cleanedViewsData['quarter_month'],
    };
  }
  const [currentData, setCurrentData] = useState(
    transposeMatrix(dataMapping?.['day-hour'])
  );
  const [currentLikesData, setCurrentLikesData] = useState(
    transposeMatrix(likesMapping?.['day-hour'])
  );

  const [currentRepliesData, setCurrentRepliesData] = useState(
    transposeMatrix(repliesMapping?.['day-hour'] || [])
  );
  const [currentRetweetsData, setCurrentRetweetsData] = useState(
    transposeMatrix(retweetMapping?.['day-hour'] || [])
  );
  const [currentCommentsData, setCurrentCommentsData] = useState(
    transposeMatrix(commentsMapping?.['day-hour'] || [])
  );
  const [currentSharesData, setCurrentSharesData] = useState(
    transposeMatrix(sharesMapping?.['day-hour'] || [])
  );

  const [currentViewsData, setCurrentViewsData] = useState(
    transposeMatrix(viewsMapping?.['day-hour'] || [])
  );
  const [currentXAxis, setCurrentXAxis] = useState(AxisHour);
  const [currentYAxis, setCurrentYAxis] = useState(AxisWeek);
  const [scale, setScale] = useState([]);
  useEffect(() => {
    const flatArray = currentData?.length > 0 ? currentData?.flat() : [];
    const minVal = Math.min(...flatArray);
    const maxVal = Math.max(...flatArray);
    const step = (maxVal - minVal) / 9;
    const intervalArray = Array.from({ length: 10 }, (_, i) =>
      Math.round(minVal + i * step)
    );
    setScale(intervalArray?.sort((a, b) => b - a));
  }, [currentData]);

  const flatArray = currentData?.length > 0 ? currentData?.flat() : [];
  const minVal = Math.min(...flatArray);
  const maxVal = Math.max(...flatArray);
  const handleFilterChange = (filterArray) => {
    const filter = filterArray?.sort((a, b) => {
      if (a.startsWith('x')) return -1;
      if (b.startsWith('x')) return 1;
      return 0;
    });
    const key = `${filter[0]?.slice(1)}-${filter[1]?.slice(1)}`;
    switch (filter[0]?.slice(1)) {
      case 'hour':
        setCurrentXAxis(AxisHour);
        setXAxis('Hour of day');
        break;
      case 'day':
        setCurrentXAxis(AxisWeek);
        setXAxis('Day of week');
        break;
      case 'month':
        setCurrentXAxis(AxisMonth);
        setXAxis('Month of year');
        break;
      case 'quarter':
        setCurrentXAxis(AxisQuarter);
        setXAxis('Quarter of year');
        break;
      default:
        break;
    }
    switch (filter[1]?.slice(1)) {
      case 'hour':
        setCurrentYAxis(AxisHour);
        setYAxis('Hour of day');
        break;
      case 'day':
        setCurrentYAxis(AxisWeek);
        setYAxis('Day of week');

        break;
      case 'month':
        setCurrentYAxis(AxisMonth);
        setYAxis('Month of year');

        break;
      case 'quarter':
        setCurrentYAxis(AxisQuarter);
        setYAxis('Quarter of year');

        break;
      default:
        break;
    }
    setCurrentData(dataMapping[key]);
    setCurrentLikesData(likesMapping[key]);
    setCurrentRepliesData(repliesMapping[key]);
    setCurrentRetweetsData(retweetMapping[key]);
    setCurrentCommentsData(commentsMapping[key]);
    setCurrentSharesData(sharesMapping[key]);
    setCurrentViewsData(viewsMapping[key]);
  };

  if (!correlationAnalysisData || isEmpty) {
    return (
      <Sentiment test-id='dynamic-correlation-graph'>
        <div>
          <Title>
            <TitleWithInfo
              title={'EngageMap'}
              infoText={
                'Heatmap tracking user engagement over time, showing the type and frequency of interactions during each period.'
              }
            />
          </Title>
        </div>
        <MainContainer>
          <div
            style={{
              color: 'rgb(99, 99, 99)',
              fontSize: '16px',
              fontWeight: '600',
            }}
          >
            Insufficient Data
          </div>
        </MainContainer>
      </Sentiment>
    );
  }

  return (
    <Sentiment id='correlation-graph'>
      <div>
        <Title>
          <TitleWithInfo
            title={'EngageMap'}
            infoText={
              infoText
            }
          />
        </Title>

        <div style={{ alignSelf: 'flex-end' }}>
          <FilterOptions
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            handleFilterChange={(data) => {
              handleFilterChange(data);
            }}
          />
        </div>
      </div>

      <MainContainer xAxis={currentXAxis}>
        <YLabel currentXAxis={currentXAxis}>{yAxis}</YLabel>
        <GridContainer xAxis={currentXAxis}>
          <div>
            <HeatmapGraphContainer xAxis={currentXAxis}>
              {currentYAxis
                ?.slice(0, currentData?.length)
                ?.map((rowData, rowIndex) => (
                  <HeatmapRowWrapper key={rowIndex}>
                    <YLabelCell xAxis={currentXAxis} yAxis={currentYAxis}>
                      {rowData}
                    </YLabelCell>
                    <HeatmapRow
                      channel={channel}
                      min={minVal}
                      max={maxVal}
                      rowData={
                        currentData?.length > 0 ? currentData[rowIndex] : []
                      }
                      likesData={
                        currentLikesData?.length > 0
                          ? currentLikesData[rowIndex]
                          : []
                      }
                      repliesData={
                        currentRepliesData?.length > 0
                          ? currentRepliesData[rowIndex]
                          : []
                      }
                      retweetData={
                        currentRetweetsData?.length > 0
                          ? currentRetweetsData[rowIndex]
                          : []
                      }
                      commentsData={
                        currentCommentsData?.length > 0
                          ? currentCommentsData[rowIndex]
                          : []
                      }
                      sharesData={
                        currentSharesData?.length > 0
                          ? currentSharesData[rowIndex]
                          : []
                      }
                      viewsData={
                        currentViewsData?.length > 0
                          ? currentViewsData[rowIndex]
                          : []
                      }
                      currentXAxis={currentXAxis}
                      colorType={selectedColor}
                    />
                  </HeatmapRowWrapper>
                ))}
            </HeatmapGraphContainer>
          </div>
          <HeatmapHeader xAxis={currentXAxis?.length > 0 ? currentXAxis : []}>
            {currentXAxis
              ?.slice(0, currentData[0]?.length)
              ?.map((label, index) => (
                <X_AxisLabel
                  key={index}
                  yAxis={currentYAxis}
                  currentXAxis={currentXAxis}
                >
                  {label}
                </X_AxisLabel>
              ))}
          </HeatmapHeader>
          <XLabel currentXAxis={currentXAxis}>{xAxis}</XLabel>
        </GridContainer>
        <ColorRangeWrapper xAxis={currentXAxis} colorType={selectedColor}>
          <div
            className={`colorIndicatorType2 ${
              selectedColor === 'type2' ? 'activeType' : ''
            }`}
            onClick={() => setSelectedColor('type2')}
          >
            <div className='label'>
              {scale?.map((data, index) => {
                return (
                  <span style={{ fontSize: '14px' }} key={index}>
                    {formatNumber(data)}
                  </span>
                );
              })}
            </div>
          </div>
        </ColorRangeWrapper>
      </MainContainer>
      <Span>{` This data is observed from ${startDate} to ${endDate}`}</Span>
    </Sentiment>
  );
};

export default DynamicCorrelationGraph;
